import { FaPlus } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import DangerBadge from '../../../../Components/Badges/DangerBadge';
import { checkPermission } from '../../../../_helpers/roles/check-roles';

function Buttons({ suspendedCount, pendingCount }) {
  const user = useSelector((state) => state.user.user);
  return (
    <div>
      <Link className="btn btn-outline-primary me-2" to="/admin/rosters/suspended_list">
        <span className="">
          <FormattedMessage id="suspended_list" />
        </span>
        <DangerBadge>{suspendedCount}</DangerBadge>
      </Link>
      <Link className="btn btn-outline-primary me-2" to="/admin/rosters/request_approval">
        <span className="">
          <FormattedMessage id="pending_list" />
        </span>
        <DangerBadge>{pendingCount}</DangerBadge>
      </Link>

      {checkPermission(user?.active_role, 'Can add resource person') && (
        <Link className="btn btn-success me-2" to="/admin/rosters/choose_type">
          <FaPlus />
          <span className="ms-2"></span>
          <FormattedMessage id="add_new" />
        </Link>
      )}
    </div>
  );
}

export default Buttons;
